import Button from '@planday-corp/ui/actions/Button';
import {blue50, grey20} from '@planday-corp/ui/styles/colors';
import {styled} from 'styled-components';

export const StyledRoundedButton = styled(Button)`
  border-radius: 0.7rem;
  border-color: ${grey20};
  border-width: 2px;
  line-height: calc(2rem - 4px);
  color: ${blue50};
`;
